import { defineAsyncComponent } from 'vue';

export { default as ContactAutoSuggest } from './components/ContactAutoSuggest';
export { default as ContactCategoryAutoSuggest } from './components/ContactCategoryAutoSuggest';
export const contactMicroFrontends = {
	ContactAutoSuggest: defineAsyncComponent(
		() => import('./components/ContactAutoSuggest/ContactAutoSuggest.vue')
	),
};
